"use client";

import { FC, MouseEvent } from "react";
import Link from "next/link";
import { useRouter, usePathname } from "next/navigation";
import useMediaQuery from "@mui/material/useMediaQuery";
import { Theme } from "@mui/material/styles";

import { useStyles } from "./styles";
import { SubscriptionType } from "@/types/user";
import { useLocalStorage } from "@/hooks/useStorage";
import UserAvatar from "@/components/profile/UserDetails/UserAvatar";
import Logo from "@/components/common/Logo";
import Watermark from "@/components/common/Watermark";
import Button from "@/components/common/PrimaryButton";

interface QuizResultHeaderProps {
  userId: number | null;
  avatarUrl: string | null;
  username: string;
  subscriptionType?: SubscriptionType;
}

const QuizResultHeader: FC<QuizResultHeaderProps> = ({
  userId,
  avatarUrl,
  username,
  subscriptionType,
}) => {
  const { classes } = useStyles();
  const router = useRouter();
  const pathname = usePathname() as string;
  const [_, setRedirectPath] = useLocalStorage("redirectPath", "/");
  const isUser = userId !== null;
  const isLargeScreen = useMediaQuery<Theme>((theme) =>
    theme.breakpoints.up("lg")
  );

  const handleSignupClick = (e: MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    setRedirectPath(pathname);
    router.push("/register");
  };

  const userContent = (
    <>
      <div className={classes.userDetailsContainer}>
        <UserAvatar
          avatarUrl={avatarUrl}
          username={username}
          avatarSize={isLargeScreen ? "55px" : "29px"}
          subscriptionType={subscriptionType}
        />
        <div className={classes.userDetails}>
          <p className={classes.username}>{username}</p>
          {subscriptionType !== "free" && (
            <p className={classes.subscriptionType}>{subscriptionType}</p>
          )}
        </div>
      </div>
      <Logo variant="icon" width={isLargeScreen ? "36px" : "21px"} />
    </>
  );

  const nonUserContent = (
    <>
      <Watermark hideText={!isLargeScreen} />
      <p className={classes.promotionalText}>
        {isLargeScreen
          ? "New Quizzes & Global Leaderboard Daily"
          : "New Quizzes Daily"}
      </p>
      <Link href="/register" onClick={handleSignupClick}>
        <Button color="secondary" className={classes.signUpButton}>
          Sign Up
        </Button>
      </Link>
    </>
  );

  return (
    <div className={classes.container}>
      {isUser ? userContent : nonUserContent}
    </div>
  );
};

export default QuizResultHeader;
